import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getEnabledMarkets } from '@/selectors/configSelectors';
import { getFilteredSupportedMarkets } from '@/helpers/featureFlagHelper';

export const useEnabledMarkets = () => {
  const enabledMarketsConfig: string = useSelector(getEnabledMarkets);

  return useMemo(
    () => getFilteredSupportedMarkets(enabledMarketsConfig),
    [enabledMarketsConfig]
  );
};
